import { render, staticRenderFns } from "./MenuPopper.vue?vue&type=template&id=5b3f4f75&scoped=true&"
import script from "./MenuPopper.vue?vue&type=script&lang=js&"
export * from "./MenuPopper.vue?vue&type=script&lang=js&"
import style0 from "./MenuPopper.vue?vue&type=style&index=0&id=5b3f4f75&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3f4f75",
  null
  
)

export default component.exports